import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetPostLikeCountsSucceed, EGetPostLikeCountsActionType, IGetPostLikeCountsSucceedParams } from './types';

export const getPostLikeCountsSucceed: (data: IGetPostLikeCountsSucceedParams) => TGetPostLikeCountsSucceed =
  actionGenerator<EGetPostLikeCountsActionType.Succeed, IGetPostLikeCountsSucceedParams>(
    EGetPostLikeCountsActionType.Succeed,
  );
